module.exports = __webpack_public_path__ + "img/12.8a6983a5.jpg";